import { auth } from 'boot/firebase';
import { ApiError } from 'src/error/customError/ApiError';
import { Sentry } from 'src/boot/sentry';
const currentUser = auth.currentUser;
export const report = (e: any): void => {
  if (Sentry) {
    Sentry.setUser({
      idp_tenant_id: currentUser?.tenantId,
      idp_uid: currentUser?.uid,
    });
    if (e instanceof ApiError) {
      Sentry.setExtra('request-id', e.requestId);
      e.message = `${e.message} (${e.code}: ${e.detail})`;
    }
    Sentry.captureException(e);
  }
};
